module.exports = __webpack_public_path__ + "media/icons/garbage-b8a3442b.svg";